// extracted by mini-css-extract-plugin
export default {"component-container":"PredefinedModuleSection_component-container__AnPL8","coming-soon":"PredefinedModuleSection_coming-soon__0kIFS"};